import { Component, computed, input, Signal } from '@angular/core';
import { WebBadgeComponent } from '@app/components/humi-design-library/badge/badge.component';
import { TaxFormBox } from '@app/models/payroll/tax-form-box.abstract.model';
import { TaxForm } from '@app/models/payroll/tax-form.abstract.model';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { TaxReturnSummaryDetailsRowComponent } from '../../tax-return-summary-details/tax-return-summary-details-row.component';

@Component({
    selector: 'app-employee-tax-form-box',
    standalone: true,
    imports: [TranslateModule, WebBadgeComponent, TaxReturnSummaryDetailsRowComponent],
    templateUrl: './employee-tax-form-box.component.html',
})
export class EmployeeTaxFormBoxComponent {
    /**
     * The taxForm (RL1 or T4)
     */
    taxForm = input.required<TaxForm>();
    boxes = input.required<TaxFormBox[]>();
    /**
     * The displayed value for all boxes in an array sorted in the same order as the boxes property.
     * Most of the time this is just a number representation of a currency, but could also be a translation value (box 45)
     */
    boxAmounts: Signal<number[] | Parameters<TranslatePipe['transform']>> = computed(
        () => this.boxes()?.map((box) => this.taxForm()[box.xmlNameCamel as keyof TaxForm]) ?? []
    );

    /**
     * Is a RL1 or a T4
     */
    returnType = computed(() => (this.taxForm().isRL1() ? 'RL1' : 'T4'));

    /**
     * Whether an amount can be fed to the translate pipe for localization
     */
    isTranslatable(
        amount: number[] | undefined | Parameters<TranslatePipe['transform']>
    ): amount is Parameters<TranslatePipe['transform']> {
        if (!amount) {
            return false;
        }
        return typeof amount === 'object';
    }
}
